module.exports = __webpack_public_path__ + "static/media/overview.100ca3dd.png";